import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import m from 'mithril';
import ResponseChart from './ResponseChart';
const T = function (key, p) {
  if (p === void 0) {
    p = {};
  }
  return app.translator.trans(`linkrobins-lr-monitoring.forum.landing.${key}`, p);
};

/**
 * The hero's monitor panel: the real monitor page, with sample data.
 *
 * It renders the same ResponseChart and the same .LrMon-chartPanel /
 * .LrMon-stats markup the signed-in page uses, so what a visitor sees here is
 * what they get — no lookalike to keep in sync. The response figure
 * random-walks and the "checked" ticker counts up, so it reads as live.
 *
 * Decorative and aria-hidden: the numbers are a sample, not a monitor.
 */
export default class LivePanel extends Component {
  ms = 482;
  secs = 0;
  timer = null;
  buckets = [];
  oninit(vnode) {
    super.oninit(vnode);
    this.buckets = this.sample();
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    this.timer = window.setInterval(() => {
      this.secs++;
      if (this.secs >= 5) {
        this.secs = 0;
        this.ms = Math.max(440, Math.min(530, this.ms + (Math.floor(Math.random() * 17) - 8)));
      }
      m.redraw();
    }, 1000);
  }
  onremove(vnode) {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
    super.onremove(vnode);
  }
  view() {
    return m("div", {
      className: "LrPanel",
      "aria-hidden": "true"
    }, m("div", {
      className: "LrMon-chartPanel"
    }, m("div", {
      className: "LrMon-chartHead"
    }, m("h3", null, T('panel_response'), m("span", {
      className: "LrMon-chartNote"
    }, T('panel_history'))), m("span", {
      className: "LrMon-checkedAt"
    }, this.secs === 0 ? T('panel_checked_now') : T('panel_checked_ago', {
      n: this.secs
    }))), m(ResponseChart, {
      buckets: this.buckets
    })), m("div", {
      className: "LrMon-stats"
    }, this.stat(T('panel_uptime'), T('panel_window'), '100.00%', 'is-good'), this.stat(T('panel_response'), T('panel_checks', {
      count: '1,440'
    }), `${this.ms} ms`, 'is-accent'), this.stat(T('panel_incidents'), T('panel_window'), '0')));
  }
  stat(label, sub, value, cls) {
    if (cls === void 0) {
      cls = '';
    }
    return m("div", {
      className: "LrMon-stat"
    }, m("div", {
      className: "LrMon-stat-text"
    }, m("div", {
      className: "LrMon-stat-label"
    }, label), m("div", {
      className: "LrMon-stat-sub"
    }, sub)), m("div", {
      className: `LrMon-stat-value ${cls}`
    }, value));
  }

  /**
   * A full day ending now, one point per 10 minutes, so the panel
   * reads as a monitor that has been running rather than one added this
   * afternoon. Centered near linkrobins.com's own measured median (about
   * 490 ms, 2026-10-11), with gentle variation and only small bumps: a lone
   * 2 s spike made the min/max band a phone draws around merged points look
   * like a second chart at 390 px.
   */
  sample() {
    let seed = 20261011;
    const rand = () => {
      seed = seed * 1103515245 + 12345 & 0x7fffffff;
      return seed / 0x7fffffff;
    };
    const count = 144;
    const step = 10 * 60 * 1000;
    const end = Math.floor(Date.now() / step) * step;
    return Array.from({
      length: count
    }, (_, i) => {
      const at = new Date(end - (count - 1 - i) * step);
      // A slow daily swell (busier evenings) plus small noise.
      const swell = Math.sin((at.getHours() + at.getMinutes() / 60 - 9) / 24 * Math.PI * 2) * 35;
      let ms = 470 + swell + Math.round((rand() - 0.5) * 60);
      if (rand() > 0.97) ms += 90 + Math.round(rand() * 80);
      return {
        at: at.toISOString(),
        label: `${String(at.getHours()).padStart(2, '0')}:${String(at.getMinutes()).padStart(2, '0')}`,
        checks: 10,
        avgMs: Math.round(ms),
        failures: 0,
        downSeconds: 0,
        spanSeconds: 600
      };
    });
  }
}
flarum.reg.add('linkrobins-lr-monitoring', 'components/LivePanel', LivePanel);